import { Drawer } from '@material-ui/core';
import { cloneDeep } from 'lodash';
import * as React from 'react';
import { Button } from '../../components/button/Button';
import { FlyoutFooter } from '../../components/flyout-components/FlyoutFooter';
import { PlanningType } from '../models/enums/planning-type';

// What the flyout shows of an order, of a dealer's pickups, a shipment or a run
interface IOrderDetail {
    orderId: string;
    description: string;
}

interface IProps {
    isOpen: boolean;
    onClose: any;
    orders: IOrderDetail[];
    title: string;
    type : PlanningType;
}

export const MetricsDetailFlyout = (props : IProps) => {

    const [orders, setOrders] = React.useState<IOrderDetail[]>([]);

    React.useEffect(() => {
        if (props.isOpen) {
            const t = cloneDeep(props.orders);            
            setOrders(t);
        }
    }, [props.isOpen]);

    const closeFlyout = () => {
        props.onClose();
    };

    const getHeader = () => {
        switch (props.type) {
            case PlanningType.Pickup:
                return "Order Details";
            case PlanningType.Delivery:
                return "Shipment Details";
            case PlanningType.Schedule:
                return "Run Details";
            default:
                return "";
        }
    };

    return (
        <Drawer
            anchor="right"
            onClose={ closeFlyout }
            open={props.isOpen}>
            <div className="stop-action-drawer stop-action-reorder-route production-module-flyout">
                <div className="row">
                    <div className="col">
                        <h1>{ getHeader() }</h1>
                        <h3>{ props.title }</h3>
                    </div>
                </div>
                
                <div className="row">
                    <div className="col">
                        {
                            orders
                                ? <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Order ID</th>
                                            <th>Description</th>
                                        </tr>                                        
                                    </thead>
                                    <tbody>                                            
                                    {
                                        orders.map((itm : IOrderDetail, idx: number) => 
                                            <tr key={`run-date-task-${idx}`}>
                                                <td>{ itm.orderId }</td>
                                                <td>{ itm.description }</td>                                               
                                            </tr>
                                        )
                                    }                                                
                                    </tbody>
                            </table>
                            : <div>No Runs Selected.<br/>How did you even get here?</div>
                        }                        
                    </div>
                </div>  
                        
                <FlyoutFooter>
                    <div className="row">
                        <div className="col">                            
                            <Button
                                text="Close"
                                classes="action"
                                testID="close-setdate-run-flyout"
                                onBtnClick={ closeFlyout } 
                            />            
                        </div>
                    </div>
                </FlyoutFooter> 
                
            </div>
        </Drawer>
    );

};